import React from 'react'
import PropTypes from 'prop-types'

// retain inline css, careful of preflight tailwind css

const TinymceContentViewer = ({ style, content, className, ...extraProps }) => (
  <>
    <style jsx global>{`
      .ylurnTinymceContent {
        max-width: 100vw !important;
      }
      .ylurnTinymceContent table {
        border: 1px solid gray !important;
      }
      .ylurnTinymceContent th {
        border: 1px solid gray !important;
      }
      .ylurnTinymceContent td {
        border: 1px solid gray !important;
      }
      .ylurnTinymceContent p {
        margin: 0 !important;
      }
    `}</style>
    {/* adding !important to table border messes up other tables */}
    <div
      className={`ylurnTinymceContent prose ${className}`}
      style={{ ...style }}
      dangerouslySetInnerHTML={{ __html: content }}
      {...extraProps}
    />
  </>
)

TinymceContentViewer.defaultProps = {
  style: {},
  className: '',
}

TinymceContentViewer.propTypes = {
  content: PropTypes.string.isRequired,
  style: PropTypes.object,
  className: PropTypes.string,
}

export default TinymceContentViewer
